const DEFAULT_BUFFER_MINUTES = 120;

export function getPredictionLockTime(
  matchDate: string | Date,
  bufferMinutes: number | null | undefined,
): Date {
  const minutes = bufferMinutes ?? DEFAULT_BUFFER_MINUTES;
  const kickoff = typeof matchDate === 'string' ? new Date(matchDate) : matchDate;
  return new Date(kickoff.getTime() - minutes * 60 * 1000);
}

export function isPredictionLocked(
  matchDate: string | Date,
  bufferMinutes: number | null | undefined,
  now: Date = new Date(),
): boolean {
  return now >= getPredictionLockTime(matchDate, bufferMinutes);
}
